import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const CookieConsent = () => {
  const { t } = useLanguage();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const consent = localStorage.getItem('qwixx_cookie_consent');
    if (!consent) {
      // Small delay to avoid showing immediately on page load
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('qwixx_cookie_consent', 'accepted');
    localStorage.setItem('qwixx_cookie_consent_date', new Date().toISOString());
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#1f2937',
      color: 'white',
      padding: '1rem',
      zIndex: 9999,
      boxShadow: '0 -2px 10px rgba(0,0,0,0.2)'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem',
        alignItems: 'center',
        textAlign: 'center'
      }}>
        <p style={{
          margin: 0,
          fontSize: '0.875rem',
          lineHeight: '1.5'
        }}>
          {t('cookieConsent.message')}
        </p>
        <div style={{
          display: 'flex',
          gap: '1rem',
          flexWrap: 'wrap',
          justifyContent: 'center'
        }}>
          <button
            onClick={acceptCookies}
            style={{
              backgroundColor: '#10b981',
              color: 'white',
              border: 'none',
              padding: '0.5rem 1.5rem',
              borderRadius: '0.375rem',
              fontSize: '0.875rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#059669'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#10b981'}
          >
            {t('cookieConsent.accept')}
          </button>
          <Link
            to="/privacy"
            style={{
              color: '#93c5fd',
              fontSize: '0.875rem',
              textDecoration: 'underline',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            {t('cookieConsent.learnMore')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
